module.exports = __webpack_public_path__ + "statics/img/MaskGroup.a5d7277e.png";